module.exports = __webpack_public_path__ + "img/位图.7a9b78bf.png";